import { Box } from '@mui/material';
import { getUrl } from 'helpers';
import GameTable from '../GameTable/GameTable';
import Loader from '../Loader/Loader';
import Wizard from '../Wizard/Wizard';

export default function LessonContainer({ children, gameTable, padding = 0, wizard }: LessonContainerProps) {
    return (
        <Box
            borderRadius={5}
            padding={2}
            paddingBottom={padding + 2}
            position="relative"
            style={{
                background: `url(${getUrl('/assets/game/background.png')}) center / cover no-repeat, linear-gradient(rgba(211, 211, 211, 0.5), rgba(211, 211, 211, 0.5))`,
            }}
        >
            <Loader />
            <Box
                alignItems={{ xs: 'center', lg: 'flex-start' }}
                display="flex"
                flexDirection={{ xs: 'column', lg: 'row-reverse' }}
                gap={3}
                justifyContent="flex-end"
                width="100%"
            >
                {gameTable !== 'center' && (
                    <Box maxWidth={{ lg: 400 }} paddingBottom={3} width="100%" zIndex={1}>
                        <Wizard {...wizard} />
                    </Box>
                )}
                <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                    gap={3}
                    justifyContent="center"
                    position="relative"
                    width="100%"
                >
                    {gameTable !== 'hidden' && (
                        <GameTable center={gameTable === 'center'} compact={gameTable === 'compact'} />
                    )}
                    {children}
                </Box>
            </Box>
        </Box>
    );
}
